import React from 'react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-left">
            <div className="footer-logo">
              <div className="logo-icon">
                <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <defs>
                    <linearGradient id="flaskGradient2" x1="0%" y1="0%" x2="100%" y2="100%">
                      <stop offset="0%" stopColor="#3b82f6" />
                      <stop offset="100%" stopColor="#06b6d4" />
                    </linearGradient>
                  </defs>
                  {/* Flask body */}
                  <path d="M14 8 L14 16 L8 32 C7 34 8 36 10 36 L30 36 C32 36 33 34 32 32 L26 16 L26 8" stroke="url(#flaskGradient2)" strokeWidth="2.5" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
                  {/* Flask neck */}
                  <rect x="13" y="4" width="14" height="4" rx="1" fill="url(#flaskGradient2)"/>
                  {/* Liquid */}
                  <path d="M11 28 Q20 24 29 28 L29 32 Q20 34 11 32 Z" fill="url(#flaskGradient2)" opacity="0.4"/>
                  {/* Bubbles */}
                  <circle cx="16" cy="30" r="2" fill="#60a5fa" opacity="0.8"/>
                  <circle cx="22" cy="28" r="1.5" fill="#60a5fa" opacity="0.6"/>
                  <circle cx="24" cy="32" r="1" fill="#60a5fa" opacity="0.7"/>
                  {/* Molecular structure accent */}
                  <circle cx="32" cy="10" r="3" fill="#06b6d4" opacity="0.8"/>
                  <circle cx="36" cy="16" r="2" fill="#3b82f6" opacity="0.6"/>
                  <line x1="33" y1="12" x2="35" y2="14" stroke="#60a5fa" strokeWidth="1.5"/>
                </svg>
              </div>
              <div className="logo-text">
                <span className="logo-chem">Asia</span>
                <span className="logo-nexus">Quimicos</span>
              </div>
            </div>
            <p className="footer-tagline">
              Asia's premier chemical marketplace connecting suppliers and buyers worldwide.
            </p>
          </div>

          <div className="footer-links">
            <div className="footer-column">
              <h4 className="footer-heading">Platform</h4>
              <ul className="footer-list">
                <li><a href="#directory">Supplier Directory</a></li>
                <li><a href="#database">Chemical Database</a></li>
                <li><a href="#market">Market Intel</a></li>
                <li><a href="#tools">Buyer Tools</a></li>
              </ul>
            </div>

            <div className="footer-column">
              <h4 className="footer-heading">Company</h4>
              <ul className="footer-list">
                <li><a href="#about">About Us</a></li>
                <li><a href="#careers">Careers</a></li>
                <li><a href="#press">Press</a></li>
                <li><a href="#contact">Contact</a></li>
              </ul>
            </div>

            <div className="footer-column">
              <h4 className="footer-heading">Resources</h4>
              <ul className="footer-list">
                <li><a href="#blog">Blog</a></li>
                <li><a href="#guides">Industry Guides</a></li>
                <li><a href="#webinars">Webinars</a></li>
                <li><a href="#api">API Access</a></li>
              </ul>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-legal">
            <a href="#privacy">Privacy Policy</a>
            <span className="divider">|</span>
            <a href="#terms">Terms of Service</a>
            <span className="divider">|</span>
            <a href="#cookies">Cookie Policy</a>
          </div>

          <div className="footer-certifications">
            <div className="cert-badge" title="REACH Compliant">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" />
                <path d="M9 12l2 2 4-4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
              <span>REACH</span>
            </div>
            <div className="cert-badge" title="ISO 9001 Certified">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" />
                <text x="12" y="16" textAnchor="middle" fontSize="10" fill="currentColor">ISO</text>
              </svg>
              <span>ISO 9001</span>
            </div>
            <div className="cert-badge" title="GMP Compliant">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" />
                <path d="M12 6v6l4 2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
              </svg>
              <span>GMP</span>
            </div>
          </div>

          <div className="footer-copyright">
            © {currentYear} AsiaQuimicos. All rights reserved.
          </div>
        </div>
      </div>

      <style jsx>{`
        .footer {
          background: rgba(15, 23, 42, 0.95);
          border-top: 1px solid rgba(59, 130, 246, 0.2);
          padding: var(--space-2xl) 0 var(--space-lg);
          margin-top: var(--space-3xl);
        }

        .footer-content {
          display: grid;
          grid-template-columns: 1fr 2fr;
          gap: var(--space-3xl);
          margin-bottom: var(--space-2xl);
          padding-bottom: var(--space-2xl);
          border-bottom: 1px solid rgba(255, 255, 255, 0.1);
        }

        .footer-left {
          max-width: 300px;
        }

        .footer-logo {
          display: flex;
          align-items: center;
          gap: var(--space-md);
          margin-bottom: var(--space-md);
        }

        .footer-logo .logo-icon {
          width: 40px;
          height: 40px;
        }

        .footer-logo .logo-text {
          display: flex;
          align-items: baseline;
          gap: var(--space-xs);
          font-family: var(--font-display);
          font-size: var(--font-xl);
          font-weight: 700;
          letter-spacing: 0.05em;
        }

        .footer-logo .logo-chem {
          color: var(--color-accent-400);
        }

        .footer-logo .logo-nexus {
          color: var(--color-accent-200);
          font-weight: 400;
        }

        .footer-tagline {
          font-size: var(--font-sm);
          color: var(--color-neutral-400);
          line-height: 1.6;
        }

        .footer-links {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: var(--space-xl);
        }

        .footer-heading {
          font-family: var(--font-display);
          font-size: var(--font-sm);
          font-weight: 600;
          color: var(--color-neutral-50);
          text-transform: uppercase;
          letter-spacing: 0.1em;
          margin-bottom: var(--space-md);
        }

        .footer-list {
          list-style: none;
          display: flex;
          flex-direction: column;
          gap: var(--space-sm);
        }

        .footer-list a {
          font-size: var(--font-sm);
          color: var(--color-neutral-400);
          transition: color var(--transition-fast);
        }

        .footer-list a:hover {
          color: var(--color-accent-400);
        }

        .footer-bottom {
          display: flex;
          align-items: center;
          justify-content: space-between;
          flex-wrap: wrap;
          gap: var(--space-md);
        }

        .footer-legal {
          display: flex;
          align-items: center;
          gap: var(--space-sm);
        }

        .footer-legal a {
          font-size: var(--font-xs);
          color: var(--color-neutral-500);
          transition: color var(--transition-fast);
        }

        .footer-legal a:hover {
          color: var(--color-accent-400);
        }

        .footer-legal .divider {
          color: var(--color-neutral-600);
        }

        .footer-certifications {
          display: flex;
          align-items: center;
          gap: var(--space-md);
        }

        .cert-badge {
          display: flex;
          align-items: center;
          gap: var(--space-xs);
          color: var(--color-neutral-400);
          cursor: help;
          transition: color var(--transition-fast);
        }

        .cert-badge:hover {
          color: var(--color-accent-400);
        }

        .cert-badge span {
          font-size: var(--font-xs);
          font-weight: 500;
        }

        .footer-copyright {
          font-size: var(--font-xs);
          color: var(--color-neutral-500);
        }

        @media (max-width: 1024px) {
          .footer-content {
            grid-template-columns: 1fr;
            gap: var(--space-xl);
          }

          .footer-left {
            max-width: none;
          }
        }

        @media (max-width: 768px) {
          .footer-links {
            grid-template-columns: repeat(2, 1fr);
          }

          .footer-bottom {
            flex-direction: column;
            align-items: flex-start;
          }

          .footer-certifications {
            order: -1;
          }
        }

        @media (max-width: 480px) {
          .footer-links {
            grid-template-columns: 1fr;
          }
        }
      `}</style>
    </footer>
  );
};

export default Footer;
